import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { WhatsNew } from '@Models';
import { NgClass } from '@angular/common';
import { AdminWhatsNewService } from '@Services';
import { LoadingSpinnerComponent } from '../../../loading-spinner/loading-spinner.component';
import { sortObjectsByVersionDescending } from '@Utils';

@Component({
  selector: 'app-version-list',
  standalone: true,
  imports: [RouterLink, NgClass, LoadingSpinnerComponent],
  templateUrl: './version-list.component.html',
  styleUrl: './version-list.component.css',
})
export class VersionListComponent implements OnInit {
  whatsNewContentArray: WhatsNew[] = [];
  isLoading = false;

  constructor(private _adminService: AdminWhatsNewService) {}

  ngOnInit() {
    this.loadWhatsNewList();
  }

  loadWhatsNewList() {
    this.isLoading = true;
    this._adminService.getAllWhatsNewSection(true).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.whatsNewContentArray = sortObjectsByVersionDescending(response);
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      },
    });
  }

  displayStatusFlag(status: string): string {
    switch (status) {
      case 'published':
        return `nhsuk-tag--green`;
      case 'dev':
        return `nhsuk-tag--blue`;
      case 'draft':
        return `nhsuk-tag--yellow`;
      default:
        return `nhsuk-tag--blue`;
    }
  }
}
